import logger from '@/util/logger';
import { toast } from 'sonner';
import { rebuildBrandSearchIndexNow } from './brandSearchIndexApi';

const log = logger('republishBrandSearchIndex');

let rebuildInFlight = false;
let rebuildAgain = false;

/**
 * Republish the index after a catalog edit without holding the admin on the callable's cold start; the
 * nightly rebuild backstops a failure. At most one rebuild is in flight, plus one rerun when an edit
 * lands meanwhile: each rebuild publishes the catalog as it read it, so one that read before the latest
 * edit must not be the last to publish.
 */
export function republishBrandSearchIndexSoon(): void {
    if (rebuildInFlight) {
        rebuildAgain = true;
        return;
    }
    rebuildInFlight = true;
    void republish().finally(() => {
        rebuildInFlight = false;
        if (!rebuildAgain) return;
        rebuildAgain = false;
        republishBrandSearchIndexSoon();
    });
}

async function republish(): Promise<void> {
    try {
        await rebuildBrandSearchIndexNow();
    } catch (err) {
        log.warn('Brand search index rebuild failed after a catalog edit (nightly rebuild will catch it)', { err });
        toast.warning('The brand index did not republish', {
            description: 'Surfaces keep the previous index until the nightly rebuild; rebuild it from Brands to retry.',
        });
    }
}
